import { render, staticRenderFns } from "./ExpenseList.vue?vue&type=template&id=60dac878&scoped=true&"
import script from "./ExpenseList.vue?vue&type=script&lang=js&"
export * from "./ExpenseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dac878",
  null
  
)

export default component.exports